<template>
  <div class="secondary-menu-nested">
    <ProfileModerateReveals></ProfileModerateReveals>
  </div>
</template>

<style>

</style>

<script>
import {mapActions, mapGetters} from "vuex";
import ProfileModerateReveals from "../../widgets/reveal/ProfileModerateReveals.vue";

export default {
  data () {
    return {
    }
  },
  mixins: [
    require('@general/lib/mixin').default
  ],
  components: {
    ProfileModerateReveals
  },
  created(){

  },
  mounted(){
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapActions([
    ]),
  },
}
</script>
